import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Header, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';

// Same CUI Popup shell as LeaveEditorConfirmationPopup. Locale staging is owned by
// HeaderMoreMenu — this component only confirms or cancels a pending pick.
const bodyCss = "b1b3bvrd";
export const UpdatePageLanguageConfirmationPopup = ({
  isOpen,
  onClose,
  onConfirm
}) => <Popup isOpen={isOpen} onClose={onClose} size="small" withCloseButton>
    <Header title={I18n.t('publisher.event_type_editor_crud.header.language_confirmation.title')} />
    <Body>
      <div className={bodyCss}>
        <BodyText size="medium">
          {I18n.t('publisher.event_type_editor_crud.header.language_confirmation.body')}
        </BodyText>
        <BodyText size="medium" color={colorTextSecondary}>
          <BodyText size="medium" weight="strong" inline>
            {I18n.t('publisher.event_type_editor_crud.header.language_confirmation.note_label')}
          </BodyText>
          {' '}
          {I18n.t('publisher.event_type_editor_crud.header.language_confirmation.note_body')}
        </BodyText>
      </div>
    </Body>
    <Footer>
      <Button appearance="secondary-outline" size="medium" label={I18n.t('publisher.action.cancel')} onClick={onClose} data-testid="editor-language-confirmation-cancel" />
      <Button appearance="primary" size="medium" label={I18n.t('publisher.action.update')} onClick={onConfirm} data-testid="editor-language-confirmation-update" />
    </Footer>
  </Popup>;

require("./update_page_language_confirmation_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./update_page_language_confirmation_popup.js");